import { render, staticRenderFns } from "./saas.vue?vue&type=template&id=5e39626a&scoped=true"
import script from "./saas.vue?vue&type=script&lang=js"
export * from "./saas.vue?vue&type=script&lang=js"
import style0 from "./saas.vue?vue&type=style&index=0&id=5e39626a&prod&lang=scss"
import style1 from "./saas.vue?vue&type=style&index=1&id=5e39626a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e39626a",
  null
  
)

export default component.exports